import { Checkbox, Input } from "antd";
import React from "react";
import { Control, Controller, FieldValues } from "react-hook-form";

export const BLANK_FILTER_VALUE = "blank";

/** Entered value wins; otherwise Blank checked sends "blank"; else no filter. */
export function resolveBlankFilterValue(
  value: string | undefined | null,
  isBlankChecked: boolean | undefined,
): string | null {
  const trimmed = value?.trim();
  if (trimmed) return trimmed;
  if (isBlankChecked) return BLANK_FILTER_VALUE;
  return null;
}

export const getBlankFilterFieldname = (fieldname: string) => `${fieldname}Blank`;

type FilterInputWithBlankProps = {
  fieldname: string;
  label: string;
  control: Control<FieldValues>;
  blankFieldname?: string;
  placeholder?: string;
  initValue?: string;
};

export const FilterInputWithBlank: React.FC<FilterInputWithBlankProps> = ({
  fieldname,
  label,
  control,
  blankFieldname = getBlankFilterFieldname(fieldname),
  placeholder,
  initValue = "",
}) => (
  <div className="ant-form-item filter-input-with-blank">
    <div className="ant-form-item-label">
      <div className="filter-input-with-blank__label-row">
        <label className="filter-input-with-blank__field-label" htmlFor={fieldname}>
          {label}
        </label>
        <Controller
          name={blankFieldname}
          control={control}
          defaultValue={false}
          render={({ field: { value, onChange } }) => (
            <Checkbox
              className="ds-checkbox filter-input-with-blank__checkbox"
              checked={Boolean(value)}
              onChange={(e) => onChange(e.target.checked)}
            >
              Blank
            </Checkbox>
          )}
        />
      </div>
    </div>
    <div className="ant-form-item-control">
      <div className="ant-form-item-control-input">
        <div className="ant-form-item-control-input-content">
          <Controller
            name={fieldname}
            control={control}
            defaultValue={initValue}
            render={({ field }) => (
              <Input {...field} id={fieldname} placeholder={placeholder ?? label} size="large" />
            )}
          />
        </div>
      </div>
    </div>
  </div>
);
